export default __webpack_public_path__ + "static/media/Nath-Richter.c871bc9c.png";